import * as React from "react";
import {faq} from "../utils";

interface IState {
    openedFaqIndex: number;
}
export default class FAQ extends React.Component<{}, IState> {
    constructor(props) {
        super(props);
        this.state = {
            openedFaqIndex: 0,
        };
    }
    public handleFaqClick = (faqIndex: number) => {
        this.setState({openedFaqIndex: faqIndex});
    }
    public componentDidMount(): void {
        window.scrollTo(0, 0);
    }

    public render() {
        return (
            <div className="mt-4">
                <div className="text-center mb-4">
                    <h3>FAQ</h3>
                </div>
                {
                    faq.map((obj, index) => {
                        return (
                            <div onClick={() => this.handleFaqClick(index)} className="my-4 faq-transition" key={index}>
                                <div className="faq-question-box">
                                    <i className={`mr-1 shubh-color fa fa-${index === this.state.openedFaqIndex ? "minus" : "plus"}-circle`} aria-hidden="true"></i>
                                    <b>{obj.question}</b>
                                </div>
                                {this.state.openedFaqIndex === index && <div className="my-4" dangerouslySetInnerHTML={{__html: obj.ans}}/>}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}
